module.exports = __webpack_public_path__ + "static/feature-dual-weather-seals-86760d2d41005687157aa626983a33e0.png";